module.exports = __webpack_public_path__ + "img/vertical_4_3_9006.295e4589.png";